import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: {
  openedListItemId: undefined | string;
  selectedPaymentMethodId: undefined | string;
  selectedPaymentGroupId: undefined | string;
} = {
  openedListItemId: undefined,
  selectedPaymentMethodId: undefined,
  selectedPaymentGroupId: undefined,
};

export const visibilitySlice = createSlice({
  name: "visibility",
  initialState: initialState,
  reducers: {
    setOpenedPaymentListItemId: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.openedListItemId = action.payload;
    },
  },
});

export const { setOpenedPaymentListItemId } = visibilitySlice.actions;

export default visibilitySlice.reducer;
